"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Buttons_1 = require("../../../Buttons");
var Icons_1 = require("../../../Icons");
var Layouts_1 = require("../../../Layouts");
var Localization_1 = require("../../../Localization");
var Theme_1 = require("../../../Theme");
var FrameworkMessagesPopup_styles_1 = require("../FrameworkMessagesPopup.styles");
var FrameworkMessagesList_styles_1 = require("./FrameworkMessagesList.styles");
exports.default = (function (_a) {
    var MessageResponses = _a.MessageResponses, OnUpdateItem = _a.OnUpdateItem;
    var buildMessageIcon = function (messageType) {
        switch (messageType) {
            case "FixableIgnorable": return React.createElement(FrameworkMessagesList_styles_1.IconWrapperDiv, { Color: Theme_1.Color.Green.G60 },
                React.createElement(Icons_1.HelpIcon, null));
            case "Blocking": return React.createElement(FrameworkMessagesList_styles_1.IconWrapperDiv, { Color: Theme_1.Color.Red.R60 },
                React.createElement(Icons_1.CloseCircleIcon, null));
            case "InformationDataError": return React.createElement(FrameworkMessagesList_styles_1.IconWrapperDiv, { Color: Theme_1.Color.Yellow.Y60 },
                React.createElement(Icons_1.AlertIcon, null));
        }
    };
    return (React.createElement(FrameworkMessagesList_styles_1.Ul, null, MessageResponses.map(function (msg, index) { return (React.createElement("li", { key: msg.RuleName },
        msg.Response ?
            React.createElement(FrameworkMessagesList_styles_1.MessageContainerDiv, null,
                buildMessageIcon(msg.Type),
                React.createElement(FrameworkMessagesPopup_styles_1.H3, null, msg.RuleName),
                React.createElement(FrameworkMessagesList_styles_1.MessageActionsDiv, { IsCollapsedView: true },
                    React.createElement(FrameworkMessagesPopup_styles_1.P, null, msg.Response),
                    React.createElement(Buttons_1.LinkButton, { Caption: Localization_1.strings.FrameworkMessagesPopup_Action_Undo, OnClick: function () { return OnUpdateItem(msg.RuleName, undefined); } })))
            :
                React.createElement(FrameworkMessagesList_styles_1.MessageContainerDiv, null,
                    buildMessageIcon(msg.Type),
                    React.createElement("div", null,
                        React.createElement(FrameworkMessagesPopup_styles_1.H3, null, msg.RuleName),
                        React.createElement(FrameworkMessagesPopup_styles_1.P, null, msg.Description),
                        React.createElement(FrameworkMessagesPopup_styles_1.P, null, msg.Item)),
                    React.createElement(FrameworkMessagesList_styles_1.MessageActionsDiv, null, msg.Type === "FixableIgnorable" &&
                        React.createElement(React.Fragment, null,
                            React.createElement(Buttons_1.SecondaryButton, { Caption: msg.FixButtonText ? msg.FixButtonText : Localization_1.strings.FrameworkMessagesPopup_Action_Fix, OnClick: function () { return OnUpdateItem(msg.RuleName, "Fixed"); } }),
                            React.createElement(Buttons_1.SecondaryButton, { Caption: msg.IgnoreButtonText ? msg.IgnoreButtonText : Localization_1.strings.FrameworkMessagesPopup_Action_Ignore, OnClick: function () { return OnUpdateItem(msg.RuleName, "Ignored"); } })))),
        index < MessageResponses.length - 1 &&
            React.createElement(FrameworkMessagesList_styles_1.LineWrapperDiv, null,
                React.createElement(Layouts_1.Line, null)))); })));
});
